import React, { useMemo, useState, useEffect } from 'react'
import { FaBook, FaThumbsUp, FaThumbsDown, FaRegIdCard, FaBuilding, FaAddressCard, FaSpinner } from 'react-icons/fa'
import { Wrapper, BarStrip, ProgressBar, TextFieldIcon, SelectFieldIcon, ModalComponent } from '../_components'
import Table from '../_components/Table'
import data from '../fixtures'
import Axios from 'axios'
import moment from 'moment'
import { Formik } from 'formik'
import { Bar, Line } from 'react-chartjs-2';
import { values } from 'lodash'
import xlsx from 'json-as-xlsx'

const steps = [
  "Pending", "Actioned"
]

const ActionField = ( record ) => {
    return (
      <div onClick={async () => {
        //await localStorage.setItem( "applicationId", record.value )
        //return window.location.reload()
      } } className="cursor-pointer w-auto md:w-20 lg:w-24 py-1 rounded bg-[#AFC836] text-xs text-black flex items-center justify-center">
        {`View`}
      </div>
    )
}

// Custom ActionField for renewals vs new tables that opens modal
const ModalActionField = ( cell, onViewClick ) => {
    return (
      <div onClick={() => {
        const original = cell?.row?.original
        onViewClick(original)
      }} className="cursor-pointer w-auto md:w-20 lg:w-24 py-1 rounded bg-[#AFC836] text-xs text-black flex items-center justify-center">
        {`View`}
      </div>
    )
}

const DistrictViewActionField = ( cell, onViewClick ) => {
    return (
      <div onClick={() => {
        onViewClick(cell?.row?.original)
      }} className="cursor-pointer w-auto md:w-20 lg:w-24 py-1 rounded bg-[#AFC836] text-xs text-black flex items-center justify-center">
        {`View`}
      </div>
    )
}



export default function Reports( ) {
    const [ servicesDropdown, setServicesDropdown ] = useState( [] )
    const [ services, setServices ] = useState( [''] )

    useEffect( () => {
        fetchIsicCodes()
    }, [])

    const downloadCertificationLevelList = async () => {
        try {
            const url = process.env.REACT_APP_API_URL+`/api/auth/certification_levels_pdf/`+certLevelStartDate+`/`+certLevelEndDate+`/`+certLevelType
            const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
            if (newWindow) newWindow.opener = null
        } catch (error) {}
    }

    const downloadGenderBasedReport = async () => {
        try {
            const url = process.env.REACT_APP_API_URL+`/api/auth/gender_report_pdf/`+genderReportStartDate+`/`+genderReportEndDate
            const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
            if (newWindow) newWindow.opener = null
        } catch (error) {}
    }

    const downloadTimelinesReport = async () => {
        try {            
            const url = process.env.REACT_APP_API_URL+`/api/auth/application_timelines/`+timelinesStartDate+`/`+timelinesEndDate
            const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
            if (newWindow) newWindow.opener = null
        } catch (error) {
            console.log(error)
        } finally {
            setTimelinesLoading(false)
        }
    }

    // Add this function to process timeline data for charts
    const processTimelinesForChart = (timelinesData) => {
        if (!timelinesData || timelinesData.length === 0) return null;

        // Group by certification level and calculate average processing time
        const levelStats = {};
        
        timelinesData.forEach(item => {
            const level = item.certification_level || 'Unknown';
            const duration = parseInt(item.duration) || 0;
            
            if (!levelStats[level]) {
                levelStats[level] = {
                    total: 0,
                    count: 0,
                    applications: []
                };
            }
            
            levelStats[level].total += duration;
            levelStats[level].count += 1;
            levelStats[level].applications.push(item);
        });

        // Calculate averages and prepare chart data
        const labels = Object.keys(levelStats);
        const averageData = labels.map(level => {
            const stats = levelStats[level];
            return Math.round(stats.total / stats.count);
        });
        
        const countData = labels.map(level => levelStats[level].count);

        return {
            averageProcessingTime: {
                labels: labels,
                datasets: [
                    {
                        label: 'Average Processing Time (days)',
                        data: averageData,
                        backgroundColor: ['#AFC836', '#36b7c8', '#f21affe3', '#2fe1a8', '#cead1a'],
                        borderColor: ['#AFC836', '#36b7c8', '#f21affe3', '#2fe1a8', '#cead1a'],
                        borderWidth: 1,
                    },
                ],
            },
            applicationCount: {
                labels: labels,
                datasets: [
                    {
                        label: 'Number of Applications',
                        data: countData,
                        backgroundColor: ['#AFC836', '#36b7c8', '#f21affe3', '#2fe1a8', '#cead1a'],
                        borderColor: ['#AFC836', '#36b7c8', '#f21affe3', '#2fe1a8', '#cead1a'],
                        borderWidth: 1,
                    },
                ],
            }
        };
    };

    const fetchTimelines = async (values) => {
        setTimelinesLoading(true)
        console.log("from date", values.from_date)
        console.log("to date", values.to_date)
        
        try {
            const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/application_timelines`, {
                from_date: values.from_date,
                to_date: values.to_date
            } )

            if( response.data ) {
                console.log("Raw response data:", response.data)
                
                // Debug: Check the structure of the first few items
                if (response.data.timelines && response.data.timelines.length > 0) {
                    console.log("First timeline item:", response.data.timelines[0])
                    console.log("First timeline item type:", typeof response.data.timelines[0])
                    console.log("First timeline item keys:", Object.keys(response.data.timelines[0]))
                }
                
                // Set the date states for download function
                setTimelinesStartDate(values.from_date)
                setTimelinesEndDate(values.to_date)

                // Check if the data exists and is an array
                let formattedTimelines = [];
                if (response.data.timelines && Array.isArray(response.data.timelines)) {
                    // If the data is already an array of objects, use it directly
                    if (response.data.timelines.length > 0 && typeof response.data.timelines[0] === 'object') {
                        formattedTimelines = response.data.timelines.map(item => ({
                            application_id: item.application_id || item.id,
                            trading_name: item.trading_name || item.name || item.applicant_name,
                            created_at: item.created_at || item.submission_date,
                            duration: item.duration || item.waiting_time || item.days,
                            certification_level: item.certification_level || item.level,
                            created_by: item.created_by || item.email || item.user_email,
                            id: item.application_id || item.id // This is needed for the ActionField
                        }));
                    } else {
                        // If it's an array of arrays, use the original mapping logic
                        const timelineKeys = [
                            "application_id",
                            "trading_name", 
                            "created_at",
                            "duration",
                            "certification_level",
                            "created_by"
                        ];
                        
                        formattedTimelines = response.data.timelines.map(row => {
                            const obj = {};
                            timelineKeys.forEach((key, idx) => {
                                obj[key] = row[idx];
                            });
                            obj.id = obj.application_id; // Add id for ActionField
                            return obj;
                        });
                    }
                }
                
                console.log("Formatted timelines:", formattedTimelines);
                setTimelinesRecords(formattedTimelines);
                
                // Process data for charts
                const chartData = processTimelinesForChart(formattedTimelines);
                setTimelinesChartData(chartData);
            }
        } catch (error) {
            console.log("Error fetching timelines:", error)
        } finally {
            setTimelinesLoading(false)
        }
    }

    const compareRenewalsVsNew = async (values) => {
        setTimelinesLoading(true)
        console.log("compareRenewalsVsNew - from date:", values.from_date)
        console.log("compareRenewalsVsNew - to date:", values.to_date)
        
        try {
            const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/itcoapplication` )
            console.log("compareRenewalsVsNew - response:", response.data)
            
            if (response.data) {
                const fromDate = moment(values.from_date, "YYYY-MM-DD")
                const toDate = moment(values.to_date, "YYYY-MM-DD").endOf('day')

                const filtered = response.data.filter(item => {
                    const createdAt = moment(item.created_at)
                    return createdAt.isSameOrAfter(fromDate) && createdAt.isSameOrBefore(toDate)
                })

                console.log("compareRenewalsVsNew - filtered data:", filtered.length, "items")

                let newCount = 0
                let renewalCount = 0
                const newList = []
                const renewalList = []

                filtered.forEach((item, index) => {
                    const purpose = (item.application_purpose || '').toString().toLowerCase()
                    console.log("compareRenewalsVsNew - purpose:", purpose)
                    if (purpose.includes('renew')) {
                        renewalCount += 1
                        renewalList.push({
                            recordId: `${renewalCount}`,
                            trading_name: item.trading_name,
                            certification_level: item.certification_level,
                            created_at: moment(item.created_at).format("DD MMM, YYYY"),
                            created_by: item.created_by,
                            id: item.id,
                            application_purpose: item.application_purpose,
                            annual_turnover: item.annual_turnover,
                            service_name: item.service_name,
                            district: item.district,
                            stage: item.stage,
                        })
                    } else {
                        newCount += 1
                        newList.push({
                            recordId: `${newCount}`,
                            trading_name: item.trading_name,
                            certification_level: item.certification_level,
                            created_at: moment(item.created_at).format("DD MMM, YYYY"),
                            created_by: item.created_by,
                            id: item.id,
                            application_purpose: item.application_purpose,
                            annual_turnover: item.annual_turnover,
                            service_name: item.service_name,
                            district: item.district,
                            stage: item.stage,
                        })
                    }
                })

                console.log("compareRenewalsVsNew - newCount:", newCount, "renewalCount:", renewalCount)

                setRenewalsVsNewChartData({
                    labels: ['New Applications', 'Renewals'],
                    datasets: [
                        {
                            label: 'Applications',
                            data: [newCount, renewalCount],
                            backgroundColor: ['#36b7c8', '#AFC836'],
                            borderColor: ['#36b7c8', '#AFC836'],
                            borderWidth: 1,
                        },
                    ],
                })
                setNewApplicationsList(newList)
                setRenewalApplicationsList(renewalList)
            }
        } catch (error) {
            console.log("compareRenewalsVsNew - error:", error)
        } finally {
            setTimelinesLoading(false)
        }
    }

    // Add this function to process certification level data for charts
    const processCertLevelForChart = (certLevelData) => {
        if (!certLevelData || certLevelData.length === 0) return null;

        // Group by certification level
        const levelStats = {};
        const stageStats = {};
        
        certLevelData.forEach(item => {
            const level = item.certification_level || 'Unknown';
            const stage = item.stage || 'Unknown';
            
            // Count by certification level
            if (!levelStats[level]) {
                levelStats[level] = 0;
            }
            levelStats[level] += 1;
            
            // Count by stage
            if (!stageStats[stage]) {
                stageStats[stage] = 0;
            }
            stageStats[stage] += 1;
        });

        // Prepare chart data for certification levels
        const levelLabels = Object.keys(levelStats);
        const levelData = levelLabels.map(level => levelStats[level]);

        // Prepare chart data for stages
        const stageLabels = Object.keys(stageStats);
        const stageData = stageLabels.map(stage => stageStats[stage]);

        return {
            certificationLevels: {
                labels: levelLabels,
                datasets: [
                    {
                        label: 'Number of Applications',
                        data: levelData,
                        backgroundColor: ['#AFC836', '#36b7c8', '#f21affe3', '#2fe1a8', '#cead1a'],
                        borderColor: ['#AFC836', '#36b7c8', '#f21affe3', '#2fe1a8', '#cead1a'],
                        borderWidth: 1,
                    },
                ],
            },
            stages: {
                labels: stageLabels,
                datasets: [
                    {
                        label: 'Number of Applications',
                        data: stageData,
                        backgroundColor: ['#AFC836', '#36b7c8', '#f21affe3', '#2fe1a8', '#cead1a', '#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4'],
                        borderColor: ['#AFC836', '#36b7c8', '#f21affe3', '#2fe1a8', '#cead1a', '#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4'],
                        borderWidth: 1,
                    },
                ],
            }
        };
    };

    const fetchIsicCodes = async (evt) => {
        try {
          const response = await Axios.get(process.env.REACT_APP_API_URL+`/api/auth/get_isic_codes`);
    
          if( response.data.message === "success" ) {
            let isicCodes = response.data.db_records
            let isicDbCodes = isicCodes.map((item) => {
              return {
                id: item.id,
                label: `${item.class+ ": " +item.description}`,
                value: item.class
              }
            }
            );
            setServicesDropdown(isicDbCodes)
          } else{
            console.log("response returned error")
          }
        } catch (error) {
          console.log(error)
        }
    }

    const applicationColumns = useMemo( () => [
        {
        Header: "#",
        accessor: "recordId"
        },
        {
        Header: "Client",
        accessor: "applicant"
        },
        {
        Header: "Annual Income",
        accessor: "annual_income"
        },
        {
        Header: "ISIC Codes",
        accessor: "isic_codes"
        },
        {
        Header: "Email",
        accessor: "email_address"
        },
        {
        Header: "Created On",
        accessor: "date"
        },
        {
        Header: "Action",
        accessor: "id",
        Cell: ActionField
        }
    ] )

    const districtsColumns = useMemo( () => [
        { Header: "#", accessor: "recordId" },
        { Header: "District", accessor: "district" },
        { Header: "No. of Applications", accessor: "district_applications" },
        {
            Header: "Action",
            accessor: "districtName",
            Cell: (props) => DistrictViewActionField(props, handleViewDistrict)
        }
    ])

    const districtBusinessColumns = useMemo( () => [
        { Header: "#", accessor: "recordId" },
        { Header: "Trading Name", accessor: "trading_name" },
        { Header: "Entity Name", accessor: "entity_name" },
        { Header: "Email", accessor: "created_by" },
        { Header: "Certification Level", accessor: "certification_level" },
        { Header: "Created On", accessor: "created_at" },
        {
            Header: "Action",
            accessor: "id",
            Cell: (props) => ModalActionField(props, handleViewApplication)
        },
    ], [])

    const genderColumns = useMemo( () => [
        {
        Header: "#",
        accessor: "recordId"
        },
        {
        Header: "Trading Name",
        accessor: "trading_name"
        },
        {
        Header: "Males",
        accessor: "no_males"
        },
        {
        Header: "Females",
        accessor: "no_females"
        },
        {
        Header: "Action",
        accessor: "districtName",
        Cell: ActionField
        }
    ])

    const simpleAppColumns = useMemo( () => [
        { Header: "#", accessor: "recordId" },
        { Header: "Applicant", accessor: "trading_name" },
        { Header: "Certification Level", accessor: "certification_level" },
        { Header: "Created On", accessor: "created_at" },
        { Header: "Created By", accessor: "created_by" },
        { 
            Header: "Action", 
            accessor: "id", 
            Cell: (props) => ModalActionField(props, handleViewApplication)
        },
    ])

    const registrationColumns = useMemo( () => [
        {
        Header: "#",
        accessor: "recordId"
        },
        {
        Header: "Email",
        accessor: "email_address"
        },
        {
        Header: "Name",
        accessor: "name"
        },
        {
        Header: "Domain",
        accessor: "domain"
        },
        {
        Header: "Created at",
        accessor: "created_at"
        },
        {
        Header: "Action",
        accessor: "districtName",
        Cell: ActionField
        }
    ])

    const certLevelColumns = useMemo( () => [
        {
        Header: "#",
        accessor: "recordId"
        },
        {
        Header: "Name",
        accessor: "name"
        },
        {
        Header: "Certificate No.",
        accessor: "certificate_number"
        },
        {
        Header: "Level",
        accessor: "certification_level"
        },
        {
        Header: "Stage",
        accessor: "stage"
        },
        {
        Header: "Contact",
        accessor: "contact"
        },
        {
        Header: "Email",
        accessor: "email_address"
        },
        {
        Header: "Created at",
        accessor: "created_at"
        },
        {
        Header: "Action",
        accessor: "id",
        Cell: ActionField
        }
    ])

    const timelinesColumns = useMemo( () => [
        { Header: "Application ID", accessor: "application_id" },
        { Header: "Applicant Name", accessor: "trading_name" },
        { Header: "Submission Date", accessor: "created_at" },
        { Header: "Waiting Time", accessor: "duration" },
        { Header: "Certification Level", accessor: "certification_level" },
        { Header: "Created By", accessor: "created_by" },
        { Header: "Action", accessor: "id", Cell: ActionField }
    ])
    
    const [ records, setRecords ] = useState( [] )
    const [ renewalRecords, setRenewalRecords ] = useState( [] )
    const [ registrationRecords, setRegistrationRecords ] = useState( [] )
    const [ certLevelRecords, setCertLevelRecords ] = useState( [] )
    const [ certLevelStartDate, setCertLevelStartDate ] = useState( [] )
    const [ certLevelEndDate, setCertLevelEndDate ] = useState( [] )
    const [ genderReportStartDate, setGenderReportStartDate ] = useState( [] )
    const [ genderReportEndDate, setGenderReportEndDate ] = useState( [] )
    const [ certLevelType, setCertLevelType ] = useState( [] )
    const [ monthlyGenericNameArray, setMonthlyGenericNameArray ] = useState( [] )
    const [ monthlyGenericCountArray, setMonthlyGenericCountArray ] = useState( [] )
    const [ monthlyIndividualsCountArray, setMonthlyIndividualsCountArray ] = useState( [] )
    const [ monthlyBusinessesCountArray, setMonthlyBusinessesCountArray ] = useState( [] )

    const [ districtRecords, setDistrictRecords ] = useState( [] )
    const [ districtGraphNames, setDistrictGraphNames ] = useState( [] )
    const [ districtGraphValues, setDistrictGraphValues ] = useState( [] )
    const [ districtReportFromDate, setDistrictReportFromDate ] = useState( "" )
    const [ districtReportToDate, setDistrictReportToDate ] = useState( "" )
    const [ showDistrictBusinessesModal, setShowDistrictBusinessesModal ] = useState( false )
    const [ districtBusinessesLoading, setDistrictBusinessesLoading ] = useState( false )
    const [ selectedDistrict, setSelectedDistrict ] = useState( "" )
    const [ districtBusinesses, setDistrictBusinesses ] = useState( [] )
    const [ genderRecords, setGenderRecords ] = useState( [] )
    const [ genderGraphNames, setGenderGraphNames ] = useState( [] )
    const [ genderGraphValues, setGenderGraphValues ] = useState( [] )
    const [ loading, setLoading ] = useState( true )
    const [ timelinesStartDate, setTimelinesStartDate ] = useState( [] )
    const [ timelinesEndDate, setTimelinesEndDate ] = useState( [] )
    const [ timelinesRecords, setTimelinesRecords ] = useState( [] )
    const [ timelinesChartData, setTimelinesChartData ] = useState( null )
    const [ timelinesLoading, setTimelinesLoading ] = useState( false )
    const [ renewalsVsNewChartData, setRenewalsVsNewChartData ] = useState( null )
    const [ newApplicationsList, setNewApplicationsList ] = useState( [] )
    const [ renewalApplicationsList, setRenewalApplicationsList ] = useState( [] )
    const [ isModalOpen, setIsModalOpen ] = useState( false )
    const [ selectedApplication, setSelectedApplication ] = useState( null )
    const [ approvedByManagerStageFilter, setApprovedByManagerStageFilter ] = useState( 'all' )
    const [ approvedByManagerFromDate, setApprovedByManagerFromDate ] = useState( '' )
    const [ approvedByManagerToDate, setApprovedByManagerToDate ] = useState( '' )
    const [ approvedByManagerSourceRecords, setApprovedByManagerSourceRecords ] = useState( [] )
    const [ approvedByManagerLoading, setApprovedByManagerLoading ] = useState( true )
    
    // Debug state changes
    React.useEffect(() => {
        console.log("isModalOpen changed to:", isModalOpen)
    }, [isModalOpen])
    
    React.useEffect(() => {
        console.log("selectedApplication changed to:", selectedApplication)
    }, [selectedApplication])

    // Function to handle view button click
    const handleViewApplication = (application) => {
        console.log("handleViewApplication called with:", application)
        console.log("Setting selectedApplication to:", application)
        console.log("Setting isModalOpen to true")
        setSelectedApplication(application)
        setIsModalOpen(true)
        console.log("State should be updated now")
    }

    const handleViewDistrict = async (row) => {
        const districtName = row?.districtName || row?.district
        if (!districtName) return

        if (!districtReportFromDate || !districtReportToDate) {
            alert("Please select From and To dates, then click Submit, before viewing district businesses.")
            return
        }

        try {
            setSelectedDistrict(districtName)
            setDistrictBusinesses([])
            setShowDistrictBusinessesModal(true)
            setDistrictBusinessesLoading(true)

            const response = await Axios.post(process.env.REACT_APP_API_URL + `/api/auth/applications_by_district`, {
                from_date: districtReportFromDate,
                to_date: districtReportToDate,
                district: districtName,
            })

            if (response.data?.success !== true) {
                alert(response.data?.message || "Failed to load district businesses.")
                return
            }

            const results = (response.data.records || []).map((app, idx) => ({
                recordId: `${idx + 1}`,
                id: app.id,
                trading_name: app.trading_name,
                entity_name: app.entity_name,
                created_by: app.created_by,
                certification_level: app.certification_level,
                created_at: moment(app.created_at).format("DD MMM, YYYY"),
            }))

            setDistrictBusinesses(results)
        } catch (error) {
            alert("Server error occurred while loading district businesses.")
            console.log(error)
        } finally {
            setDistrictBusinessesLoading(false)
        }
    }

    // Function to close modal
    const handleCloseModal = () => {
        setIsModalOpen(false)
        setSelectedApplication(null)
    }

    const viewGeneratedCertificate = async (applicationId) => {
        try {
            const url = process.env.REACT_APP_API_URL+`/api/auth/view_unsigned_certificate/${applicationId}`
            const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
            if (newWindow) newWindow.opener = null
        } catch (error) {}
    }

    const ApprovedByManagerActionField = (cell) => {
        return (
            <div
                onClick={() => viewGeneratedCertificate(cell?.value)}
                className="cursor-pointer w-auto md:w-28 lg:w-32 py-1 rounded bg-[#AFC836] text-xs text-black flex items-center justify-center"
            >
                {`View Certificate`}
            </div>
        )
    }

    const approvedByManagerColumns = useMemo(() => [
        {
            Header: "#",
            accessor: "recordId"
        },
        {
            Header: "Business Trading Name",
            accessor: "applicant"
        },
        {
            Header: "Entity Name",
            accessor: "entity_name"
        },
        {
            Header: "Email",
            accessor: "email_address"
        },
        {
            Header: "Stage",
            accessor: "stage",
            Cell: (cell) => (
                <span className="text-xs text-gray-700">
                    {showStage(String(cell?.value ?? "")) || cell?.value}
                </span>
            )
        },
        {
            Header: "Date Approved",
            accessor: "date"
        },
        {
            Header: "Action",
            accessor: "id",
            Cell: ApprovedByManagerActionField
        }
    ], [])

    const approvedByManagerRecords = useMemo(() => {
        const safe = Array.isArray(approvedByManagerSourceRecords) ? approvedByManagerSourceRecords : []
        return safe
            .filter(r => approvedByManagerStageFilter === 'all' || String(r?.stage) === approvedByManagerStageFilter)
            .sort((a, b) => (a?.applicant || '').localeCompare(b?.applicant || '', undefined, { sensitivity: 'base' }))
            .map((r, idx) => ({ ...r, recordId: `${idx + 1}` }))
    }, [approvedByManagerSourceRecords, approvedByManagerStageFilter])

    const fetchApprovedByManagerRecords = async (fromDate = approvedByManagerFromDate, toDate = approvedByManagerToDate) => {
        setApprovedByManagerLoading( true )
        try {
            const params = new URLSearchParams()
            if (fromDate) params.append('from_date', fromDate)
            if (toDate) params.append('to_date', toDate)

            const queryString = params.toString()
            const url = process.env.REACT_APP_API_URL + `/api/auth/approved_by_manager_report` + (queryString ? `?${queryString}` : '')
            const response = await Axios.get( url )
            if( response.data ) {
                const results = response.data.map((result) => ({
                    stage: result.stage,
                    applicant: result.trading_name,
                    entity_name: result.entity_name,
                    email_address: result.created_by,
                    date: result.date_approved
                        ? moment( result.date_approved ).format( "DD MMM, YYYY" )
                        : '',
                    id: result.id
                }))
                setApprovedByManagerSourceRecords( results )
            }
        } catch (error) {
            alert( "Server error occured." )
        } finally {
            setApprovedByManagerLoading( false )
        }
    }

    const handleApprovedByManagerDateSearch = () => {
        if (approvedByManagerFromDate && approvedByManagerToDate && moment(approvedByManagerFromDate).isAfter(moment(approvedByManagerToDate))) {
            alert('From date cannot be after To date.')
            return
        }
        fetchApprovedByManagerRecords(approvedByManagerFromDate, approvedByManagerToDate)
    }

    const clearApprovedByManagerDateFilter = () => {
        setApprovedByManagerFromDate('')
        setApprovedByManagerToDate('')
        fetchApprovedByManagerRecords('', '')
    }

    React.useEffect( () => {
        if( localStorage.getItem( "link" ) === "approved_by_manager_report" ) {
            setApprovedByManagerStageFilter( 'all' )
            fetchApprovedByManagerRecords()
        }
    }, [] )

    React.useEffect( () => {
        if( loading ) {
            fetchApplications();
            fetchDistrictApps();
        }
    },[ loading ])

    const fetchApplications = async () => {
        try {
            const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/itcoapplication` ) 
            if( response.data ) {
                const results = response.data.map( ( result, index ) => {
                    return {
                        recordId: `${index+1}`,
                        stage: result.stage,
                        applicant: result.trading_name,
                        entity_name: result.entity_name,
                        annual_income: result.annual_turnover,
                        isic_codes: result.service_name,
                        email_address: result.created_by,
                        date: moment( result.created_at ).format( "DD MMM, YYYY" ),
                        id: result.id
                    }
                } ).filter( record => { 
                    return record.status?.toUpperCase() !== "APPROVED"
                } )

                //update the state
                setRecords( results )
                setLoading( false )

                // Extract gender details
                const genderResults = response.data.map((result, index) => ({
                    recordId: `${index + 1}`,
                    trading_name: result.trading_name,
                    stage: result.stage,
                    no_males: parseInt(result.no_males) || 0, // Ensure it's a number
                    no_females: parseInt(result.no_females) || 0, // Ensure it's a number
                })).filter(record => record.stage > 1);

                setGenderRecords(genderResults);

                // Compute total males and females
                const totalMales = genderResults.reduce((sum, record) => sum + record.no_males, 0);
                const totalFemales = genderResults.reduce((sum, record) => sum + record.no_females, 0);

                console.log("Total Males:", parseInt(totalMales));
                console.log("Total Females:", parseInt(totalFemales));

                let genderKeys = ["Males", "Females"];
                setGenderGraphNames(genderKeys);

                let genderVals = [];
                genderVals.push(parseInt(totalMales));
                genderVals.push(parseInt(totalFemales));
                setGenderGraphValues(genderVals);        
            }
        } catch (error) {
            alert( "Server error occured." )
            setLoading( false )
        }
    }

    const fetchDistrictApps = async () => {
        try {
            const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/itcoapplication` ) 
            if( response.data ) {
                let districtsArray = [];
                const results = response.data.map( ( result, index ) => {

                    if (districtsArray.hasOwnProperty(result.district)) {
                        const previousQty = districtsArray[result.district];
                        districtsArray[result.district] = previousQty + 1;
                    } else {
                        districtsArray[result.district] = 1;
                    }
                } )

                let counter = 0;
                let districtsObj = [];
                let graphNames = [];
                let graphValues = [];
                for (const key in districtsArray) {
                    counter++;
                    var record = {'recordId':counter, 'district':key, 'district_applications':districtsArray[key], 'districtName':key }
                    districtsObj[counter] = record;
                    graphNames.push(key);
                    graphValues.push(districtsArray[key]);
                }

                setDistrictRecords(districtsObj)
                setDistrictGraphNames(graphNames)
                setDistrictGraphValues(graphValues)
            }
        } catch (error) {
            console.log(error)
            alert( "Server error occured while loading district stats." )
            setLoading( false )
        }
    }

    const showStage  = (stage_number) => {
        switch(stage_number){
            case "1":
                return "VERIFICATION";
            case "2":
                return "FINANCE";
            case "3":
                return "AUDITOR";
            case "4":
                return "AUDITOR";
            case "5":
                return "LEVEL 1";
            case "6":
                return "LEVEL 2";
            case "7":
                return "LEVEL 3";
            case "8":
                return "APPROVAL";
            case "9":
                return "APPROVED";
            default:
              return
        }
    }

    const exportApprovedByManagerToExcel = () => {
        if (!approvedByManagerRecords.length) {
            alert('No records to export.')
            return
        }

        const sheetData = [{
            sheet: 'Approved by the Manager DRLS',
            columns: [
                { label: '#', value: 'recordId' },
                { label: 'Business Trading Name', value: 'applicant' },
                { label: 'Entity Name', value: 'entity_name' },
                { label: 'Email', value: 'email_address' },
            ],
            content: approvedByManagerRecords
        }]

        try {
            xlsx(sheetData, {
                fileName: `approved_by_manager_report_${moment().format('YYYY-MM-DD')}`,
                extraLength: 3,
                writeMode: 'writeFile',
            })
        } catch (error) {
            console.error(error)
            alert('Failed to export Excel file.')
        }
    }

    const exportApprovedByManagerToPDF = () => {
        try {
            const params = new URLSearchParams()
            if (approvedByManagerStageFilter !== 'all') {
                params.append('stage', approvedByManagerStageFilter)
            }
            if (approvedByManagerFromDate) {
                params.append('from_date', approvedByManagerFromDate)
            }
            if (approvedByManagerToDate) {
                params.append('to_date', approvedByManagerToDate)
            }

            const queryString = params.toString()
            const url = process.env.REACT_APP_API_URL + `/api/auth/approved_by_manager_report_pdf` + (queryString ? `?${queryString}` : '')
            const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
            if (newWindow) newWindow.opener = null
        } catch (error) {
            alert('Failed to export PDF.')
        }
    }

    const handleCertificationLevels = async (values) => {
        setTimelinesLoading(true)
        try {
            const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/search_certification_level`, {
                from_date: values.from_date,
                to_date: values.to_date,
                certification_level: values.certification_level
            })
            setCertLevelStartDate(values.from_date)
            setCertLevelEndDate(values.to_date)
            setCertLevelType(values.certification_level)
            console.log(response)

            const results = response.data.map( ( result, index ) => {
                return {
                    recordId: `${index+1}`,
                    name: result.trading_name,
                    certificate_number: result.certificate_serial_number,
                    certification_level: result.certification_level,
                    email_address: result.created_by,
                    stage: showStage(result.stage),
                    contact: result.contact_phone_number,
                    created_at: moment( result.created_at ).format( "DD MMM, YYYY" ),
                    id: result.id
                }
            } )
            console.log(results)

            //update the state
            setCertLevelRecords( results )
            setLoading( false )
            setTimelinesLoading(false)
        } catch (error) {}
    }

    const handleApplicationsPerDistrictSearch = async (values) => {
        try {
            setDistrictReportFromDate(values.from_date)
            setDistrictReportToDate(values.to_date)
            const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/search_apps_per_district`, {
                from_date: values.from_date,
                to_date: values.to_date
            } )
    
            if( response.data.success === true ) {
                //console.log( response.data.records )
                let districtsArray = [];
                const results = response.data.records.map( ( result, index ) => {
                    if (districtsArray.hasOwnProperty(result.district)) {
                        const previousQty = districtsArray[result.district];
                        districtsArray[result.district] = previousQty + 1;
                    } else {
                        districtsArray[result.district] = 1;
                    }
                } )

                let counter = 0;
                let districtsObj = [];
                let graphNames = [];
                let graphValues = [];
                for (const key in districtsArray) {
                    counter++;
                    var record = {'recordId':counter, 'district':key, 'district_applications':districtsArray[key], 'districtName':key }
                    districtsObj[counter] = record;
                    graphNames.push(key);
                    graphValues.push(districtsArray[key]);
                }
                setDistrictRecords(districtsObj)
                setDistrictGraphNames(graphNames)
                setDistrictGraphValues(graphValues)
            }
        } catch (error) {}
    }

    const handleApplicationsPerGenderSearch = async (values) => {
        setGenderReportStartDate(values.from_date)
        setGenderReportEndDate(values.to_date)

        try {
            const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/itcoapplication` ) 
            if( response.data ) {                
                setLoading( false )

                // Extract gender details
                const genderResults = response.data
                    .map((result, index) => ({
                        recordId: `${index + 1}`,
                        trading_name: result.trading_name,
                        stage: result.stage,
                        date: result.created_at,
                        no_males: parseInt(result.no_males) || 0,
                        no_females: parseInt(result.no_females) || 0,
                    }))
                    .filter(record => {
                        // Only include if stage > 1 and date is within range
                        const recordDate = moment(record.date, moment.ISO_8601);
                        const fromDate = moment(values.from_date, "YYYY-MM-DD");
                        const toDate = moment(values.to_date, "YYYY-MM-DD").endOf('day');
                        return (
                            record.stage > 1 &&
                            recordDate.isSameOrAfter(fromDate) &&
                            recordDate.isSameOrBefore(toDate)
                        );
                    });

                setGenderRecords(genderResults);

                // Compute total males and females
                const totalMales = genderResults.reduce((sum, record) => sum + record.no_males, 0);
                const totalFemales = genderResults.reduce((sum, record) => sum + record.no_females, 0);

                console.log("Total Males:", parseInt(totalMales));
                console.log("Total Females:", parseInt(totalFemales));

                let genderKeys = ["Males", "Females"];
                setGenderGraphNames(genderKeys);

                let genderVals = [];
                genderVals.push(parseInt(totalMales));
                genderVals.push(parseInt(totalFemales));
                setGenderGraphValues(genderVals);        
            }
        } catch (error) {
            alert( "Server error occured." )
            setLoading( false )
        }
    }

    const handleIsicCodesSearch = async (values) => {

        try {
            const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/search_apps_per_isic_code`, {
                from_date: values.from_date,
                to_date: values.to_date,
                isic_code: values.isic_code
            } )
    
            if( response.data.success === true ) {
                const results = response.data.records.map( ( result, index ) => {
                    return {
                        recordId: `${index+1}`,
                        stage: result.stage,
                        applicant: result.trading_name,
                        annual_income: result.annual_turnover,
                        isic_codes: result.service_name,
                        email_address: result.created_by,
                        date: moment( result.created_at ).format( "DD MMM, YYYY" ),
                        id: result.id
                    }
                } ).filter( record => { 
                    return record.service_name?.toUpperCase() !== ""
                } )

                //update the state
                setRecords( results )
                setLoading( false )
            }
        } catch (error) {}
    }

    const handleRenewalsSearch = async (values) => {

        try {
            const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/search_renewal_applications`, {
                from_date: values.from_date,
                to_date: values.to_date
            } )
            console.log(response.data)
    
            if( response.data.success === true ) {
                const results = response.data.records.map( ( result, index ) => {
                    return {
                        recordId: `${index+1}`,
                        stage: result.stage,
                        applicant: result.trading_name,
                        annual_income: result.annual_turnover,
                        isic_codes: result.service_name,
                        email_address: result.created_by,
                        date: moment( result.created_at ).format( "DD MMM, YYYY" ),
                        id: result.id
                    }
                } ).filter( record => { 
                    return record.service_name?.toUpperCase() !== ""
                } )

                //update the state
                setRenewalRecords( results )
                setLoading( false )
            }
        } catch (error) {}
    }

    const handleRegistrationsSearch = async (values) => {

        try {
            const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/search_registrations`, {
                from_date: values.from_date,
                to_date: values.to_date
            } )
    
            if( response.data.success === true ) {
                const results = response.data.records.map( ( result, index ) => {
                    return {
                        recordId: `${index+1}`,
                        name: result.first_name,
                        email_address: result.email_address,
                        region: result.region,
                        domain: result.domain,
                        created_at: moment( result.created_at ).format( "DD MMM, YYYY" ),
                        id: result.id
                    }
                } ).filter( record => { 
                    return record.user_role?.toUpperCase() !== "APPLICANT"
                } )
                //console.log(results)
                setMonthlyGenericNameArray(response.data.month_generic_name_array)
                setMonthlyGenericCountArray(response.data.month_generic_count_array)
                setMonthlyIndividualsCountArray(response.data.individuals_array)
                setMonthlyBusinessesCountArray(response.data.businesses_array)

                //update the state
                setRegistrationRecords( results )
                setLoading( false )
            }
        } catch (error) {}
    }

    const general = {
        labels: monthlyGenericNameArray,
        datasets: [
            {
            label: 'Total Monthly Registrations',
            data: monthlyGenericCountArray,
            backgroundColor: '#36b7c8',
            },
        ],
    };

    const individuals = {
        labels: monthlyGenericNameArray,
        datasets: [
            {
            label: 'Individuals',
            data: monthlyIndividualsCountArray,
            backgroundColor: '#2fe1a8',
            },
        ],
    };

    const businesses = {
        labels: monthlyGenericNameArray,
        datasets: [
            {
            label: 'Businesses',
            data: monthlyBusinessesCountArray,
            backgroundColor: '#f21affe3',
            },
        ],
    };

    const options = {
        scales: {
            y: {
                beginAtZero: true,
            },
        },
        elements: {
            bar: {
              borderWidth: 2,
            },
        },
    };

    const per_district_numbers = {
        labels: districtGraphNames,
        datasets: [
            {
            label: 'Districts',
            data: districtGraphValues,
            backgroundColor: '#f21affe3',
            },
        ],
    };

    const per_district_options = {
        scales: {
            y: {
                beginAtZero: true,
            },
        },
        elements: {
            bar: {
              borderWidth: 2,
            },
        },
    };

    const per_gender_numbers = {
        labels: genderGraphNames,
        datasets: [
            {
            label: 'Ratio of males to females',
            data: genderGraphValues,
            backgroundColor: ['#f21affe3', '#74bcde'],
            }
        ],
    };

    const per_gender_options = {
        scales: {
            y: {
                beginAtZero: true,
            },
        },
        elements: {
            bar: {
              borderWidth: 2,
            },
        },
    };

    if( localStorage.getItem( "link" ) === "user_registrations_report" ) {
        return (
            <>
            <Wrapper>
                <div className="flex flex-col h-full">
                    <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
                        <div className="px-5 py-2 text-sm bg-white text-[#AFC836] font-bold text-lg">
                        {`Registrations Report`}
                        </div>
                        
                        <div className="flex items-center justify-between my-5">
                            <div className="flex items-center justify-between px-5 py-2 text-sm bg-white w-full h-44">
                                <Bar data={general} options={options} />

                                <Bar data={individuals} options={options} />

                                <Bar data={businesses} options={options} />
                            </div>
                        </div>

                        <div className="flex flex-col justify-center w-full bg-white">
                            <Formik initialValues={{
                                from_date: values.from_date,
                                to_date: values.to_date,

                                }} onSubmit={handleRegistrationsSearch}>
                                { ( { handleSubmit, handleBlur, handleChange, values } ) => {
                                        return (
                                            <form className="my-2 bg-white" onSubmit={handleSubmit}>
                                                <div className="flex row px-5">
                                                    <div className="basis-1/4">
                                                        <TextFieldIcon 
                                                            type="date"
                                                            name="from_date"
                                                            handleChange={handleChange}
                                                            handleBlur={handleBlur}
                                                            value={values.from_date}
                                                            iconComponent={<FaAddressCard color={`#AFC836`} />} 
                                                            label="From"
                                                            required={true}
                                                            disabled={false}
                                                            question="From" 
                                                        />
                                                    </div>

                                                    <div className="basis-1/4">
                                                        <TextFieldIcon 
                                                            type="date"
                                                            name="to_date"
                                                            handleChange={handleChange}
                                                            handleBlur={handleBlur}
                                                            value={values.to_date}
                                                            iconComponent={<FaAddressCard color={`#AFC836`} />} 
                                                            label="To"
                                                            required={true}
                                                            disabled={false}
                                                            question="To" 
                                                        />
                                                    </div>

                                                    <div className="basis-1/4">
                                                        <div className="w-full pt-8 grid grid-cols-1">
                                                            <button className="bg-cyan-500 px-2 py-1 mx-2 text-sm text-white rounded-sm" type="submit" name="submit">Submit</button>
                                                        </div>
                                                    </div>                                                    
                                                </div>
                                            </form>
                                        )
                                    }  }
                            </Formik>
                        
                            <Table 
                            rightButton={false}
                            rightBtnCallback={ () => {}}
                            rightButtonLabel={null}
                            label="My Reports"
                            columns={registrationColumns}
                            data={registrationRecords}
                            hidePagination={false}
                            exportToExcel={() => {}}
                            exportToCSV={() => {}}
                            />
                        </div>
                    </div>
                </div>
            </Wrapper>
            
            {/* Application Details Modal */}
            <ModalComponent title="Application Details" open={isModalOpen}>
                {selectedApplication && (
                    <div className="flex flex-col">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div className="space-y-3">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Application ID</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.id || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Trading Name</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.trading_name || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Certification Level</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.certification_level || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Created On</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.created_at || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Created By</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.created_by || 'N/A'}</p>
                                </div>
                            </div>
                            
                            <div className="space-y-3">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Application Purpose</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.application_purpose || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Annual Turnover</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.annual_turnover || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Service Name</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.service_name || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">District</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.district || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Stage</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.stage || 'N/A'}</p>
                                </div>
                            </div>
                        </div>
                        
                        <button
                            onClick={handleCloseModal}
                            className="cursor-pointer my-3 w-auto md:w-48 lg:w-64 py-1 rounded bg-[#aa314f] text-xs text-white flex items-center justify-center"
                        >
                            Close
                        </button>
                    </div>
                )}
            </ModalComponent>

            <ModalComponent title={`Businesses in ${selectedDistrict || 'District'}`} open={showDistrictBusinessesModal}>
                <div className="flex flex-col">
                    {districtBusinessesLoading ? (
                        <div className="flex flex-col items-center justify-center py-10">
                            <FaSpinner className="animate-spin text-[#AFC836] text-3xl mb-3" />
                            <span className="text-sm text-gray-600">{`Loading businesses...`}</span>
                        </div>
                    ) : (
                        <Table
                            rightButton={false}
                            rightBtnCallback={() => {}}
                            rightButtonLabel={null}
                            label="Businesses"
                            columns={districtBusinessColumns}
                            data={districtBusinesses}
                            hidePagination={false}
                            defaultPageSize={25}
                            pageSizeOptions={[10, 25, 50, 100]}
                            exportToExcel={() => {}}
                            exportToCSV={() => {}}
                        />
                    )}

                    <div className="flex justify-end mt-4">
                        <button
                            className="bg-gray-700 px-4 py-2 text-sm text-white rounded-sm"
                            onClick={() => {
                                setShowDistrictBusinessesModal(false)
                                setSelectedDistrict("")
                                setDistrictBusinesses([])
                            }}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </ModalComponent>
            </>
        )
    }

    if( localStorage.getItem( "link" ) === "approved_by_manager_report" ) {
        return (
            <Wrapper>
                <div className="flex flex-col h-full">
                    <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
                        <div className="px-5 py-2 text-sm bg-white text-[#AFC836] font-bold text-lg">
                            {`Approved by the Manager / DRLS`}
                        </div>

                        <div className="flex flex-wrap items-end gap-3 px-5 py-3 bg-white mt-3 border-b border-gray-200">
                            <label className="flex items-center gap-2 text-sm text-gray-700">
                                <span className="font-medium">{`Stage`}</span>
                                <select
                                    value={approvedByManagerStageFilter}
                                    onChange={(e) => setApprovedByManagerStageFilter(e.target.value)}
                                    disabled={approvedByManagerLoading}
                                    className="border border-gray-300 rounded-sm px-2 py-1 text-sm min-w-[140px] disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    <option value="all">{`All Stages`}</option>
                                    <option value="8">{`APPROVAL`}</option>
                                    <option value="9">{`APPROVED`}</option>
                                </select>
                            </label>
                            <label className="flex flex-col gap-1 text-sm text-gray-700">
                                <span className="font-medium">{`From`}</span>
                                <input
                                    type="date"
                                    value={approvedByManagerFromDate}
                                    onChange={(e) => setApprovedByManagerFromDate(e.target.value)}
                                    disabled={approvedByManagerLoading}
                                    className="border border-gray-300 rounded-sm px-2 py-1 text-sm disabled:opacity-50 disabled:cursor-not-allowed"
                                />
                            </label>
                            <label className="flex flex-col gap-1 text-sm text-gray-700">
                                <span className="font-medium">{`To`}</span>
                                <input
                                    type="date"
                                    value={approvedByManagerToDate}
                                    onChange={(e) => setApprovedByManagerToDate(e.target.value)}
                                    disabled={approvedByManagerLoading}
                                    className="border border-gray-300 rounded-sm px-2 py-1 text-sm disabled:opacity-50 disabled:cursor-not-allowed"
                                />
                            </label>
                            <button
                                type="button"
                                onClick={handleApprovedByManagerDateSearch}
                                disabled={approvedByManagerLoading}
                                className="bg-[#AFC836] hover:bg-[#9ab42f] disabled:opacity-50 disabled:cursor-not-allowed px-3 py-1 text-sm text-black rounded-sm"
                            >
                                {approvedByManagerLoading ? (
                                    <span className="inline-flex items-center gap-2">
                                        <FaSpinner className="animate-spin" />
                                        {`Searching...`}
                                    </span>
                                ) : (
                                    `Search`
                                )}
                            </button>
                            {(approvedByManagerFromDate || approvedByManagerToDate) && (
                                <button
                                    type="button"
                                    onClick={clearApprovedByManagerDateFilter}
                                    disabled={approvedByManagerLoading}
                                    className="bg-gray-500 hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed px-3 py-1 text-sm text-white rounded-sm"
                                >
                                    {`Clear Dates`}
                                </button>
                            )}
                            <button
                                type="button"
                                onClick={exportApprovedByManagerToExcel}
                                disabled={approvedByManagerLoading}
                                className="bg-cyan-600 hover:bg-cyan-700 disabled:opacity-50 disabled:cursor-not-allowed px-3 py-1 text-sm text-white rounded-sm"
                            >
                                {`Export to Excel`}
                            </button>
                            <button
                                type="button"
                                onClick={exportApprovedByManagerToPDF}
                                disabled={approvedByManagerLoading}
                                className="bg-cyan-600 hover:bg-cyan-700 disabled:opacity-50 disabled:cursor-not-allowed px-3 py-1 text-sm text-white rounded-sm"
                            >
                                {`Export to PDF`}
                            </button>
                        </div>

                        <div className="flex flex-col justify-center w-full bg-white min-h-[240px]">
                            {approvedByManagerLoading ? (
                                <div className="flex flex-col items-center justify-center py-16 px-5">
                                    <FaSpinner className="animate-spin text-[#AFC836] text-3xl mb-3" />
                                    <span className="text-sm text-gray-600">{`Loading report data...`}</span>
                                </div>
                            ) : (
                                <Table
                                    rightButton={false}
                                    rightBtnCallback={() => {}}
                                    rightButtonLabel={null}
                                    label="Approved by the Manager/DRLS"
                                    columns={approvedByManagerColumns}
                                    data={approvedByManagerRecords}
                                    hidePagination={false}
                                    defaultPageSize={100}
                                    pageSizeOptions={[ 10, 25, 50, 100 ]}
                                    exportToExcel={exportApprovedByManagerToExcel}
                                    exportToCSV={() => {}}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </Wrapper>
        )
    }

    if( localStorage.getItem( "link" ) === "per_district_apps_report" ) {
        return (
            <>
            <Wrapper>
                <div className="flex flex-col h-full">
                    <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
                        <div className="px-5 py-2 text-sm bg-white text-[#AFC836] font-bold text-lg">
                        {`Application Per Districts Report`}
                        </div>

                        <div className="flex items-center justify-between my-5">
                            <div className="flex items-center justify-between px-5 py-2 text-sm bg-white w-full h-44">
                                <Bar data={per_district_numbers} options={per_district_options} />
                            </div>
                        </div>

                        <div className="flex flex-col justify-center w-full bg-white">

                        <Formik initialValues={{
                                    from_date: values.from_date,
                                    to_date: values.to_date,

                                }} onSubmit={handleApplicationsPerDistrictSearch}>
                                { ( { handleSubmit, handleBlur, handleChange, values } ) => {
                                        return (
                                            <form className="my-2 bg-white" onSubmit={handleSubmit}>
                                                <div className="flex row px-5">
                                                    <div className="basis-1/4">
                                                        <TextFieldIcon 
                                                            type="date"
                                                            name="from_date"
                                                            handleChange={handleChange}
                                                            handleBlur={handleBlur}
                                                            value={values.from_date}
                                                            iconComponent={<FaAddressCard color={`#AFC836`} />} 
                                                            label="From"
                                                            required={true}
                                                            disabled={false}
                                                            question="From" 
                                                        />
                                                    </div>

                                                    <div className="basis-1/4">
                                                        <TextFieldIcon 
                                                            type="date"
                                                            name="to_date"
                                                            handleChange={handleChange}
                                                            handleBlur={handleBlur}
                                                            value={values.to_date}
                                                            iconComponent={<FaAddressCard color={`#AFC836`} />} 
                                                            label="To"
                                                            required={true}
                                                            disabled={false}
                                                            question="To" 
                                                        />
                                                    </div>

                                                    <div className="basis-1/4">
                                                        <div className="w-full pt-8 grid grid-cols-1">
                                                            <button className="bg-cyan-500 px-2 py-1 mx-2 text-sm text-white rounded-sm" type="submit" name="submit">Submit</button>
                                                        </div>
                                                    </div>                                                    
                                                </div>
                                            </form>
                                        )
                                    }  }
                                </Formik>
                        
                            <Table 
                            rightButton={false}
                            rightBtnCallback={ () => {}}
                            rightButtonLabel={null}
                            label="My Reports"
                            columns={districtsColumns}
                            data={districtRecords}
                            hidePagination={false}
                            exportToExcel={() => {}}
                            exportToCSV={() => {}}
                            />
                        </div>
                    </div>
                </div>
            </Wrapper>
            
            {/* Application Details Modal */}
            <ModalComponent title="Application Details" open={isModalOpen}>
                {selectedApplication && (
                    <div className="flex flex-col">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div className="space-y-3">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Application ID</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.id || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Trading Name</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.trading_name || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Certification Level</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.certification_level || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Created On</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.created_at || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Created By</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.created_by || 'N/A'}</p>
                                </div>
                            </div>
                            
                            <div className="space-y-3">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Application Purpose</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.application_purpose || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Annual Turnover</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.annual_turnover || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Service Name</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.service_name || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">District</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.district || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Stage</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.stage || 'N/A'}</p>
                                </div>
                            </div>
                        </div>
                        
                        <button
                            onClick={handleCloseModal}
                            className="cursor-pointer my-3 w-auto md:w-48 lg:w-64 py-1 rounded bg-[#aa314f] text-xs text-white flex items-center justify-center"
                        >
                            Close
                        </button>
                    </div>
                )}
            </ModalComponent>
            </>
        )
    }

    if( localStorage.getItem( "link" ) === "renewal_applications_report" ) {
        return (
            <>
            <Wrapper>
                <div className="flex flex-col h-full">
                    <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
                        <div className="px-5 py-2 text-sm bg-white text-[#AFC836] font-bold text-lg">
                        {`Renewals`}
                        </div>

                        <div className="flex flex-col justify-center w-full bg-white">

                            <Formik initialValues={{
                                    from_date: values.from_date,
                                    to_date: values.to_date

                                }} onSubmit={handleRenewalsSearch}>
                                { ( { handleSubmit, handleBlur, handleChange, values } ) => {
                                        return (
                                            <form className="my-2 bg-white" onSubmit={handleSubmit}>
                                                <div className="flex px-5">
                                                    <div className="basis-1/4">
                                                        <TextFieldIcon 
                                                            type="date"
                                                            name="from_date"
                                                            handleChange={handleChange}
                                                            handleBlur={handleBlur}
                                                            value={values.from_date}
                                                            iconComponent={<FaAddressCard color={`#AFC836`} />} 
                                                            label="From"
                                                            required={true}
                                                            disabled={false}
                                                            question="From" 
                                                        />
                                                    </div>

                                                    <div className="basis-1/4">
                                                        <TextFieldIcon 
                                                            type="date"
                                                            name="to_date"
                                                            handleChange={handleChange}
                                                            handleBlur={handleBlur}
                                                            value={values.to_date}
                                                            iconComponent={<FaAddressCard color={`#AFC836`} />} 
                                                            label="To"
                                                            required={true}
                                                            disabled={false}
                                                            question="To" 
                                                        />
                                                    </div>

                                                    <div className="flex-col pt-2">
                                                        <div className="w-full py-6 grid grid-cols-1">
                                                            <button className="bg-cyan-500 px-2 py-1 mx-2 text-sm text-white rounded-sm" type="submit" name="submit">Submit</button>
                                                        </div>
                                                    </div>                                                    
                                                </div>
                                            </form>
                                        )
                                    }  }
                                </Formik>
                        
                            <Table 
                            rightButton={false}
                            rightBtnCallback={ () => {}}
                            rightButtonLabel={null}
                            label="My Reports"
                            columns={applicationColumns}
                            data={renewalRecords}
                            hidePagination={false}
                            exportToExcel={() => {}}
                            exportToCSV={() => {}}
                            />
                        </div>
                    </div>
                </div>
            </Wrapper>
            
            {/* Application Details Modal */}
            <ModalComponent title="Application Details" open={isModalOpen}>
                {selectedApplication && (
                    <div className="flex flex-col">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div className="space-y-3">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Application ID</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.id || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Trading Name</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.trading_name || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Certification Level</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.certification_level || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Created On</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.created_at || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Created By</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.created_by || 'N/A'}</p>
                                </div>
                            </div>
                            
                            <div className="space-y-3">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Application Purpose</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.application_purpose || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Annual Turnover</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.annual_turnover || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Service Name</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.service_name || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">District</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.district || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Stage</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.stage || 'N/A'}</p>
                                </div>
                            </div>
                        </div>
                        
                        <button
                            onClick={handleCloseModal}
                            className="cursor-pointer my-3 w-auto md:w-48 lg:w-64 py-1 rounded bg-[#aa314f] text-xs text-white flex items-center justify-center"
                        >
                            Close
                        </button>
                    </div>
                )}
            </ModalComponent>
            </>
        )
    }

    if( localStorage.getItem( "link" ) === "isic_codes_report" ) {
        return (
            <>
            <Wrapper>
                <div className="flex flex-col h-full">
                    <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
                        <div className="px-5 py-2 text-sm bg-white text-[#AFC836] font-bold text-lg">
                        {`ISIC Codes Report`}
                        </div>

                        <div className="flex flex-col justify-center w-full bg-white">

                            <Formik initialValues={{
                                    isic_code: "",
                                    from_date: values.from_date,
                                    to_date: values.to_date

                                }} onSubmit={handleIsicCodesSearch}>
                                { ( { handleSubmit, handleChange, handleBlur, values } ) => {
                                        return (
                                            <form className="my-2 bg-white" onSubmit={handleSubmit}>
                                                <div className="flex px-5">
                                                    <div className="basis-1/4">
                                                        <TextFieldIcon 
                                                            type="date"
                                                            name="from_date"
                                                            handleChange={handleChange}
                                                            handleBlur={handleBlur}
                                                            value={values.from_date}
                                                            iconComponent={<FaAddressCard color={`#AFC836`} />} 
                                                            label="From"
                                                            required={true}
                                                            disabled={false}
                                                            question="From" 
                                                        />
                                                    </div>

                                                    <div className="basis-1/4">
                                                        <TextFieldIcon 
                                                            type="date"
                                                            name="to_date"
                                                            handleChange={handleChange}
                                                            handleBlur={handleBlur}
                                                            value={values.to_date}
                                                            iconComponent={<FaAddressCard color={`#AFC836`} />} 
                                                            label="To"
                                                            required={true}
                                                            disabled={false}
                                                            question="To" 
                                                        />
                                                    </div>

                                                    <div className="basis-1/4 pt-2">
                                                        <SelectFieldIcon 
                                                            name="isic_code"
                                                            handleChange={handleChange}
                                                            handleBlur={handleBlur}
                                                            value={values.isic_code}
                                                            iconComponent={<FaBuilding color={`#AFC836`} />} 
                                                            label="ISIC Code"
                                                            required={false}
                                                            disabled={false}
                                                            options={servicesDropdown.map( ( { id, label, value } ) => {
                                                                return { id, label, value }
                                                            } )}
                                                            question="ISIC Code" 
                                                        />
                                                    </div>

                                                    <div className="flex-col pt-2">
                                                        <div className="w-full py-6 grid grid-cols-1">
                                                            <button className="bg-cyan-500 px-2 py-1 mx-2 text-sm text-white rounded-sm" type="submit" name="submit">Submit</button>
                                                        </div>
                                                    </div>                                                    
                                                </div>
                                            </form>
                                        )
                                    }  }
                                </Formik>
                        
                            <Table 
                            rightButton={false}
                            rightBtnCallback={ () => {}}
                            rightButtonLabel={null}
                            label="My Reports"
                            columns={applicationColumns}
                            data={records}
                            hidePagination={false}
                            exportToExcel={() => {}}
                            exportToCSV={() => {}}
                            />
                        </div>
                    </div>
                </div>
            </Wrapper>
            
            {/* Application Details Modal */}
            <ModalComponent title="Application Details" open={isModalOpen}>
                {selectedApplication && (
                    <div className="flex flex-col">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div className="space-y-3">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Application ID</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.id || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Trading Name</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.trading_name || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Certification Level</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.certification_level || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Created On</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.created_at || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Created By</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.created_by || 'N/A'}</p>
                                </div>
                            </div>
                            
                            <div className="space-y-3">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Application Purpose</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.application_purpose || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Annual Turnover</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.annual_turnover || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Service Name</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.service_name || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">District</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.district || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Stage</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.stage || 'N/A'}</p>
                                </div>
                            </div>
                        </div>
                        
                        <button
                            onClick={handleCloseModal}
                            className="cursor-pointer my-3 w-auto md:w-48 lg:w-64 py-1 rounded bg-[#aa314f] text-xs text-white flex items-center justify-center"
                        >
                            Close
                        </button>
                    </div>
                )}
            </ModalComponent>
            </>
        )
    }

    if( localStorage.getItem( "link" ) === "per_gender_apps_report" ) {
        // Calculate total males and females
        const totalMales = genderRecords.reduce((sum, record) => sum + (parseInt(record.no_males) || 0), 0);
        const totalFemales = genderRecords.reduce((sum, record) => sum + (parseInt(record.no_females) || 0), 0);

        // Add total row as the last row
        const genderRecordsWithTotal = [
            ...genderRecords,
            {
            recordId: '',
            trading_name: <b>Total</b>,
            no_males: <b>{totalMales}</b>,
            no_females: <b>{totalFemales}</b>,
            // Fill other columns with empty or null as needed
            }
        ];

        return (
            <>
            <Wrapper>
            <div className="flex flex-col h-full">
                <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
                <div className="px-5 py-2 text-sm bg-white text-[#AFC836] font-bold text-lg">
                    {`Application Per Gender Report`}
                </div>

                <div className="flex items-center justify-between my-5">
                    <div className="flex items-center justify-between px-5 py-2 text-sm bg-white w-full h-44">
                    <Bar data={per_gender_numbers} options={per_gender_options} />
                    </div>
                </div>

                <div className="flex flex-col justify-center w-full bg-white">

                    <Formik initialValues={{
                    from_date: values.from_date,
                    to_date: values.to_date,
                    }} onSubmit={handleApplicationsPerGenderSearch}>
                    {({ handleSubmit, handleBlur, handleChange, values }) => {
                        return (
                        <form className="my-2 bg-white" onSubmit={handleSubmit}>
                            <div className="flex row px-5">
                            <div className="basis-1/4">
                                <TextFieldIcon
                                type="date"
                                name="from_date"
                                handleChange={handleChange}
                                handleBlur={handleBlur}
                                value={values.from_date}
                                iconComponent={<FaAddressCard color={`#AFC836`} />}
                                label="From"
                                required={true}
                                disabled={false}
                                question="From"
                                />
                            </div>

                            <div className="basis-1/4">
                                <TextFieldIcon
                                type="date"
                                name="to_date"
                                handleChange={handleChange}
                                handleBlur={handleBlur}
                                value={values.to_date}
                                iconComponent={<FaAddressCard color={`#AFC836`} />}
                                label="To"
                                required={true}
                                disabled={false}
                                question="To"
                                />
                            </div>

                            <div className="basis-1/4">
                                <div className="w-full pt-8 grid grid-cols-1">
                                <button className="bg-cyan-500 px-2 py-1 mx-2 text-sm text-white rounded-sm" type="submit" name="submit">Submit</button>
                                </div>
                            </div>
                            </div>
                        </form>
                        )
                    }}
                    </Formik>

                    <a onClick={async () => {
                            downloadGenderBasedReport()
                        } } className="cursor-pointer text-lg text-blue-600 curser-pointer">
                        {` Dowload Report`}
                    </a>

                    <Table
                    rightButton={false}
                    rightBtnCallback={() => { }}
                    rightButtonLabel={null}
                    label="My Reports"
                    columns={genderColumns.map(col => {
                        // Remove the Action column for the total row
                        if (col.Header === "Action") {
                        return {
                            ...col,
                            Cell: (row) => {
                            // If this is the last row (total), don't render the button
                            if (row.row.index === genderRecordsWithTotal.length - 1) {
                                return null;
                            }
                            return ActionField(row);
                            }
                        }
                        }
                        return col;
                    })}
                    data={genderRecordsWithTotal}
                    hidePagination={false}
                    exportToExcel={() => { }}
                    exportToCSV={() => { }}
                    />
                </div>
                </div>
                </div>
            </Wrapper>
            
            {/* Application Details Modal */}
            <ModalComponent title="Application Details" open={isModalOpen}>
                {selectedApplication && (
                    <div className="flex flex-col">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div className="space-y-3">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Application ID</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.id || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Trading Name</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.trading_name || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Certification Level</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.certification_level || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Created On</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.created_at || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Created By</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.created_by || 'N/A'}</p>
                                </div>
                            </div>
                            
                            <div className="space-y-3">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Application Purpose</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.application_purpose || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Annual Turnover</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.annual_turnover || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Service Name</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.service_name || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">District</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.district || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Stage</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.stage || 'N/A'}</p>
                                </div>
                            </div>
                        </div>
                        
                        <button
                            onClick={handleCloseModal}
                            className="cursor-pointer my-3 w-auto md:w-48 lg:w-64 py-1 rounded bg-[#aa314f] text-xs text-white flex items-center justify-center"
                        >
                            Close
                        </button>
                    </div>
                )}
            </ModalComponent>
            </>
        )
    }

    if( localStorage.getItem( "link" ) === "certification_levels_report" ) {
        return (
            <>
            <Wrapper>
                <div className="flex flex-col h-full">
                    <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
                        <div className="px-5 py-2 text-sm bg-white text-[#AFC836] font-bold text-lg">
                        {`Certification Levels Report`}
                        </div>

                        <div className="flex flex-col justify-center w-full bg-white">

                        <Formik initialValues={{
                            from_date: values.from_date,
                            to_date: values.to_date,
                            certification_level: values.certification_level,

                        }} onSubmit={handleCertificationLevels}>
                        { ( { handleSubmit, handleBlur, handleChange, values } ) => {
                                return (
                                    <form className="my-2 bg-white" onSubmit={handleSubmit}>
                                        <div className="flex row px-5">
                                            <div className="basis-1/4">
                                                <TextFieldIcon 
                                                    type="date"
                                                    name="from_date"
                                                    handleChange={handleChange}
                                                    handleBlur={handleBlur}
                                                    value={values.from_date}
                                                    iconComponent={<FaAddressCard color={`#AFC836`} />} 
                                                    label="From"
                                                    required={true}
                                                    disabled={false}
                                                    question="From" 
                                                />
                                            </div>

                                            <div className="basis-1/4">
                                                <TextFieldIcon 
                                                    type="date"
                                                    name="to_date"
                                                    handleChange={handleChange}
                                                    handleBlur={handleBlur}
                                                    value={values.to_date}
                                                    iconComponent={<FaAddressCard color={`#AFC836`} />} 
                                                    label="To"
                                                    required={true}
                                                    disabled={false}
                                                    question="To" 
                                                />
                                            </div>

                                            <div className="basis-1/4">
                                                <SelectFieldIcon 
                                                    spaced
                                                    name="certification_level"
                                                    handleChange={evt => {
                                                        handleChange(evt)
                                                    }}
                                                    handleBlur={handleBlur}
                                                    value={values.certification_level}
                                                    iconComponent={<FaBuilding color={`#AFC836`} />} 
                                                    label="Certification Level"
                                                    options={[ 
                                                        { id: 1, value: "CCL1", label: "CCL1" },
                                                        { id: 2, value: "CCL2", label: "CCL2" },
                                                        { id: 3, value: "CCL3", label: "CCL3" },
                                                        { id: 4, value: "ET", label: "ET" },
                                                        { id: 5, value: "All", label: "All Certification Levels" }
                                                    ]}
                                                    question="Certification Level" />
                                            </div>

                                            <div className="basis-1/4">
                                                <div className="w-full pt-8 grid grid-cols-1">
                                                    <button className="bg-cyan-500 px-2 py-1 mx-2 text-sm text-white rounded-sm" 
                                                        type="submit" 
                                                        name="submit"
                                                        disabled={timelinesLoading}
                                                        >
                                                            {timelinesLoading ? (
                                                                <>
                                                                    <FaSpinner className="animate-spin mr-2" />
                                                                    Loading...
                                                                </>
                                                            ) : (
                                                                'Submit'
                                                            )}
                                                    </button>
                                                </div>
                                            </div>                                                    
                                        </div>
                                    </form>
                                )
                            }  }
                        </Formik>

                        <a onClick={async () => {
                                downloadCertificationLevelList()
                            } } className="cursor-pointer text-xs text-blue-600 curser-pointer">
                            {` Dowload List`}
                        </a>

                        {/* Charts for Certification Levels Report */}
                        {certLevelRecords && certLevelRecords.length > 0 && (
                            <>
                                {/* Chart for Applications by Certification Level */}
                                <div className="flex flex-col items-center bg-white py-6">
                                    <div className="w-full md:w-3/4">
                                        <Bar
                                            data={processCertLevelForChart(certLevelRecords).certificationLevels}
                                            options={{
                                                responsive: true,
                                                plugins: {
                                                    legend: {
                                                        display: true,
                                                        position: 'top',
                                                    },
                                                    title: {
                                                        display: true,
                                                        text: 'Applications by Certification Level',
                                                    },
                                                },
                                                scales: {
                                                    y: {
                                                        title: {
                                                            display: true,
                                                            text: 'Number of Applications',
                                                        },
                                                        beginAtZero: true,
                                                    },
                                                    x: {
                                                        title: {
                                                            display: true,
                                                            text: 'Certification Level',
                                                        },
                                                    },
                                                },
                                            }}
                                        />
                                    </div>
                                </div>
                            </>
                        )}
                        
                        <Table 
                        rightButton={false}
                        rightBtnCallback={ () => {}}
                        rightButtonLabel={null}
                        label="My Reports"
                        columns={certLevelColumns}
                        data={certLevelRecords}
                        hidePagination={false}
                        exportToExcel={() => {}}
                        exportToCSV={() => {}}
                        />
                        </div>
                    </div>
                </div>
            </Wrapper>
            
            {/* Application Details Modal */}
            <ModalComponent title="Application Details" open={isModalOpen}>
                {selectedApplication && (
                    <div className="flex flex-col">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div className="space-y-3">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Application ID</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.id || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Trading Name</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.trading_name || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Certification Level</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.certification_level || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Created On</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.created_at || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Created By</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.created_by || 'N/A'}</p>
                                </div>
                            </div>
                            
                            <div className="space-y-3">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Application Purpose</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.application_purpose || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Annual Turnover</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.annual_turnover || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Service Name</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.service_name || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">District</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.district || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Stage</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.stage || 'N/A'}</p>
                                </div>
                            </div>
                        </div>
                        
                        <button
                            onClick={handleCloseModal}
                            className="cursor-pointer my-3 w-auto md:w-48 lg:w-64 py-1 rounded bg-[#aa314f] text-xs text-white flex items-center justify-center"
                        >
                            Close
                        </button>
                    </div>
                )}
            </ModalComponent>
            </>
        )
    }

    if( localStorage.getItem( "link" ) === "timelines_report" ) {
        return (
            <Wrapper>
                <div className="flex flex-col h-full">
                    <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
                        <div className="px-5 py-2 text-sm bg-white text-[#AFC836] font-bold text-lg">
                            {`Timelines Report`}
                            <Formik initialValues={{
                                from_date: values.from_date,
                                to_date: values.to_date

                            }} onSubmit={fetchTimelines}>
                            { ( { handleSubmit, handleBlur, handleChange, values } ) => {
                                    return (
                                        <form className="my-2 bg-white" onSubmit={handleSubmit}>
                                            <div className="flex px-5">
                                                <div className="basis-1/4">
                                                    <TextFieldIcon 
                                                        type="date"
                                                        name="from_date"
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        value={values.from_date}
                                                        iconComponent={<FaAddressCard color={`#AFC836`} />} 
                                                        label="From"
                                                        required={true}
                                                        disabled={false}
                                                        question="From" 
                                                    />
                                                </div>

                                                <div className="basis-1/4">
                                                    <TextFieldIcon 
                                                        type="date"
                                                        name="to_date"
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        value={values.to_date}
                                                        iconComponent={<FaAddressCard color={`#AFC836`} />} 
                                                        label="To"
                                                        required={true}
                                                        disabled={false}
                                                        question="To" 
                                                    />
                                                </div>

                                                <div className="flex-col pt-2">
                                                    <div className="w-full py-6 grid grid-cols-1">
                                                        <button
                                                            className="bg-cyan-500 px-2 py-1 mx-2 text-sm text-white rounded-sm flex items-center justify-center"
                                                            type="submit"
                                                            name="submit"
                                                            disabled={timelinesLoading}
                                                        >
                                                            {timelinesLoading ? (
                                                                <>
                                                                    <FaSpinner className="animate-spin mr-2" />
                                                                    Loading...
                                                                </>
                                                            ) : (
                                                                'Submit'
                                                            )}
                                                        </button>
                                                    </div>
                                                </div>                                                    
                                            </div>
                                        </form>
                                    )
                                }  }
                            </Formik>

                            <a
                                onClick={async () => {
                                    try {
                                        const url = process.env.REACT_APP_API_URL + `/api/auth/timelines_report_print`
                                        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
                                        if (newWindow) newWindow.opener = null
                                    } catch (error) {} finally {
                                        setTimelinesLoading(false)
                                    }
                                }}
                                className="cursor-pointer ml-10 text-blue-400 font-normal"
                            >
                                Click to view PDF
                            </a>
                        </div>


                        {/* Chart for Average Processing Time by Certification Level */}
                        <div className="flex flex-col items-center bg-white py-6">
                            <div className="w-full md:w-3/4">
                                {timelinesChartData && timelinesChartData.averageProcessingTime ? (
                                    <Bar
                                        data={timelinesChartData.averageProcessingTime}
                                        options={{
                                            responsive: true,
                                            plugins: {
                                                legend: {
                                                    display: true,
                                                    position: 'top',
                                                },
                                                title: {
                                                    display: true,
                                                    text: 'Average Processing Time by Certification Level',
                                                },
                                            },
                                            scales: {
                                                y: {
                                                    title: {
                                                        display: true,
                                                        text: 'Days',
                                                    },
                                                    beginAtZero: true,
                                                },
                                                x: {
                                                    title: {
                                                        display: true,
                                                        text: 'Certification Level',
                                                    },
                                                },
                                            },
                                        }}
                                    />
                                ) : (
                                    <div className="text-center text-gray-500 py-8">
                                        No data available. Please select a date range and click Submit to load timeline data.
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="flex flex-col justify-center w-full bg-white">
                            <Table
                                rightButton={false}
                                rightBtnCallback={() => {}}
                                rightButtonLabel={null}
                                label="Timelines Report"
                                columns={timelinesColumns}
                                data={timelinesRecords}
                                hidePagination={false}
                                exportToExcel={() => {}}
                                exportToCSV={() => {}}
                            />
                        </div>
                    </div>
                </div>
            </Wrapper>
        )
    }

    if( localStorage.getItem( "link" ) === "renewals_vs_new_applications" ) {
        return (
            <>
            <Wrapper>
                <div className="flex flex-col h-full">
                    <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
                        <div className="px-5 py-2 text-sm bg-white text-[#AFC836] font-bold text-lg">
                            {`Renewals vs New Applications`}
                            <Formik initialValues={{
                                from_date: values.from_date,
                                to_date: values.to_date

                            }} onSubmit={compareRenewalsVsNew}>
                            { ( { handleSubmit, handleBlur, handleChange, values } ) => {
                                    return (
                                        <form className="my-2 bg-white" onSubmit={handleSubmit}>
                                            <div className="flex px-5">
                                                <div className="basis-1/4">
                                                    <TextFieldIcon 
                                                        type="date"
                                                        name="from_date"
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        value={values.from_date}
                                                        iconComponent={<FaAddressCard color={`#AFC836`} />} 
                                                        label="From"
                                                        required={true}
                                                        disabled={false}
                                                        question="From" 
                                                    />
                                                </div>

                                                <div className="basis-1/4">
                                                    <TextFieldIcon 
                                                        type="date"
                                                        name="to_date"
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        value={values.to_date}
                                                        iconComponent={<FaAddressCard color={`#AFC836`} />} 
                                                        label="To"
                                                        required={true}
                                                        disabled={false}
                                                        question="To" 
                                                    />
                                                </div>

                                                <div className="flex-col pt-2">
                                                    <div className="w-full py-6 grid grid-cols-1">
                                                        <button
                                                            className="bg-cyan-500 px-2 py-1 mx-2 text-sm text-white rounded-sm flex items-center justify-center"
                                                            type="submit"
                                                            name="submit"
                                                            compareRenewalsVsNew            disabled={timelinesLoading}
                                                        >
                                                            {timelinesLoading ? (
                                                                <>
                                                                    <FaSpinner className="animate-spin mr-2" />
                                                                    Loading...
                                                                </>
                                                            ) : (
                                                                'Submit'
                                                            )}
                                                        </button>
                                                    </div>
                                                </div>                                                    
                                            </div>
                                        </form>
                                    )
                                }  }
                            </Formik>

                            <a
                                onClick={async () => {
                                    try {
                                        const url = process.env.REACT_APP_API_URL + `/api/auth/timelines_report_print`
                                        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
                                        if (newWindow) newWindow.opener = null
                                    } catch (error) {} finally {
                                        setTimelinesLoading(false)
                                    }
                                }}
                                className="cursor-pointer ml-10 text-blue-400 font-normal"
                            >
                                Click to view PDF
                            </a>
                        </div>

                        {/* Chart for New vs Renewals */}
                        <div className="flex flex-col items-center bg-white py-6">
                            <div className="w-full md:w-3/4">
                                {renewalsVsNewChartData ? (
                                    <Bar
                                        data={renewalsVsNewChartData}
                                        options={{
                                            responsive: true,
                                            plugins: {
                                                legend: {
                                                    display: true,
                                                    position: 'top',
                                                },
                                                title: {
                                                    display: true,
                                                    text: 'New Applications vs Renewals',
                                                },
                                            },
                                            scales: {
                                                y: {
                                                    title: {
                                                        display: true,
                                                        text: 'Number of Applications',
                                                    },
                                                    beginAtZero: true,
                                                },
                                                x: {
                                                    title: {
                                                        display: true,
                                                        text: 'Application Purpose',
                                                    },
                                                },
                                            },
                                        }}
                                    />
                                ) : (
                                    <div className="text-center text-gray-500 py-8">
                                        Submit a date range to compare renewals and new applications.
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Tables for New and Renewal Applications */}
                        <div className="flex flex-col bg-white pb-10">
                            <div className="px-5 py-2 text-sm text-[#AFC836] font-bold">
                                {`New Applications`}
                            </div>
                            <Table 
                                rightButton={false}
                                rightBtnCallback={ () => {} }
                                rightButtonLabel={null}
                                label=""
                                columns={simpleAppColumns}
                                data={newApplicationsList}
                                hidePagination={false}
                                exportToExcel={() => {}}
                                exportToCSV={() => {}}
                            />

                            <div className="px-5 py-2 mt-8 text-sm text-[#AFC836] font-bold">
                                {`Renewal Applications`}
                            </div>
                            <Table 
                                rightButton={false}
                                rightBtnCallback={ () => {} }
                                rightButtonLabel={null}
                                label=""
                                columns={simpleAppColumns}
                                data={renewalApplicationsList}
                                hidePagination={false}
                                exportToExcel={() => {}}
                                exportToCSV={() => {}}
                            />
                        </div>
                    </div>
                </div>
            </Wrapper>
            
            {/* Application Details Modal */}
            <ModalComponent title="Application Details" open={isModalOpen}>
                {selectedApplication && (
                    <div className="flex flex-col">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div className="space-y-3">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Application ID</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.id || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Trading Name</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.trading_name || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Certification Level</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.certification_level || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Created On</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.created_at || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Created By</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.created_by || 'N/A'}</p>
                                </div>
                            </div>
                            
                            <div className="space-y-3">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Application Purpose</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.application_purpose || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Annual Turnover</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.annual_turnover || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Service Name</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.service_name || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">District</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.district || 'N/A'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Stage</label>
                                    <p className="mt-1 text-sm text-gray-900">{selectedApplication.stage || 'N/A'}</p>
                                </div>
                            </div>
                        </div>
                        
                        <button
                            onClick={handleCloseModal}
                            className="cursor-pointer my-3 w-auto md:w-48 lg:w-64 py-1 rounded bg-[#aa314f] text-xs text-white flex items-center justify-center"
                        >
                            Close
                        </button>
                    </div>
                )}
            </ModalComponent>
            </>
        )
    }
}